/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerClearAssessmentMutationResponse, ComparisonsControllerClearAssessmentPathParams } from "../../models/comparisonsController/ComparisonsControllerClearAssessment";

function getComparisonsControllerClearAssessmentUrl(id: ComparisonsControllerClearAssessmentPathParams["id"], changeId: ComparisonsControllerClearAssessmentPathParams["changeId"]) {
  const res = { method: 'DELETE', url: `/api/v1/comparisons/${id}/changes/${changeId}/assessments` as const }  
  return res
}

/**
 * @summary Clear the assessment for a comparison change
 * {@link /api/v1/comparisons/:id/changes/:changeId/assessments}
 */
export async function comparisonsControllerClearAssessment(id: ComparisonsControllerClearAssessmentPathParams["id"], changeId: ComparisonsControllerClearAssessmentPathParams["changeId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerClearAssessmentMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "DELETE", url : getComparisonsControllerClearAssessmentUrl(id, changeId).url.toString(), ... requestConfig })  
  return res.data
}